module.exports = __webpack_public_path__ + "img/sld_scb_2_t1_green.3b0e6254.svg";